<div class="lessons-list-container">
  <mat-expansion-panel
    #panelRef
    expanded="true"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="section-header noselect">
          <!-- <div class="section-number">Section: {{ sectionNumber + 1 }}</div> -->
          <div class="course-title">
            <h3>
              {{"courses.embed.lessons" | translate}}
            </h3>
          </div>
        </div>
      </mat-panel-title>
      <mat-panel-description>
        <div class="section-data">
          <span *ngIf="sectionLessons">
            0/{{calculateAllLessonsLength()}}
          </span>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <ng-container *ngIf="sectionLessons">
      <div
        class="lesson-row mat-row"
        *ngFor="let lesson of getSectionLessons(); let index = index"
        [routerLink]="[]"
      >
        <ng-container>
          <div class="lesson-icon" *ngIf="lesson.type == 'video'">
            <span class="material-symbols-outlined"> play_circle </span>
          </div>

          <div class="lesson-icon" *ngIf="lesson.type == 'download'">
            <span class="material-symbols-outlined"> get_app </span>
          </div>

          <div class="lesson-icon" *ngIf="lesson.type == 'text-only'">
            <span class="material-symbols-outlined"> text_snippet </span>
          </div>

          <div class="lesson-icon" *ngIf="lesson.type == 'quiz'">
            <span class="material-symbols-outlined"> quiz </span>
          </div>

          <div class="lesson-icon" *ngIf="lesson.type == 'assignment'">
            <span class="material-symbols-outlined"> assignment </span>
          </div>

          <div class="lesson-icon" *ngIf="lesson.type == 'audio'">
            <span class="material-symbols-outlined"> audiotrack </span>
          </div>
        </ng-container>

        <div class="lesson-description">
          {{ lesson.title }}
        </div>

        <div class="filler"></div>

        <div class="lesson-duration" *ngIf="lesson.type == 'video'">
          {{ lesson.videoDuration | duration }}
        </div>

        <div class="lesson-pro">
      <span
        class="material-symbols-outlined"
        *ngIf="!lesson.free"
        title="This is a Premium lesson"
      >
        lock
      </span>
        </div>

      </div>
    </ng-container>

  </mat-expansion-panel>
</div>
